import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import useSession from 'hooks/useSession'

import AlertBox from 'components/AlertBox/AlertBox'

import styles from '../controllers/Dialog.module.sass'

const PersonalAccidentWarning = (props) => {
	const { task } = props
	const { i18n } = useGlobal()
	const { user: sessionUser } = useSession()

	const IS_ADMINISTRATIVE = ['manager', 'admin'].some((role) =>
		sessionUser?.roles.includes(role)
	)
	const IS_PERSONAL_ACCIDENT = task.segment?.id === 'AP'

	return (
		IS_ADMINISTRATIVE &&
		IS_PERSONAL_ACCIDENT && (
			<AlertBox
				className={styles['alert-box']}
				type='warning'
				items={[
					{
						title: i18n`Personal accident`,
						text: i18n`Plafond must be validated before approval`,
					},
				]}
			/>
		)
	)
}

export default PersonalAccidentWarning
